import { useNavigate } from 'react-router-dom'

import { bottles } from 'src/axious/bottles'
import { useGetTypeOfBottleFromUrl } from 'src/hooks'
import { convertToISOWithCurrentTime } from 'src/utils/convertToISOWithCurrentTime'
import { handleAxiosError } from 'src/utils/errorHandling'
import { useCreateBottle } from 'src/zustand/stores/createBottle.store'

export const useHandleCreateBottle = (
  bottleType: string,
  bottleDate: any,
  bottleName: string,
  bottleAmount: string,
  targetOfBottle: string,
) => {
  const clearAllFields = useCreateBottle((state) => state.clearAllFields)
  const navigate = useNavigate()

  const startDate = convertToISOWithCurrentTime(bottleDate.from)
  const availableUntil = convertToISOWithCurrentTime(bottleDate.to)

  const typeOfBottle = useGetTypeOfBottleFromUrl()
  if (typeOfBottle === 'charitable') {
    bottleAmount = '0'
  }

  const sendingRequestToCreateBottle = async () => {
    let type: string

    if (bottleType === 'Charitable') {
      type = 'CHARITABLE'
    } else {
      type = Number(bottleAmount) === 0 ? 'ANY' : 'FIXED'
    }

    try {
      await bottles('post', '', {
        name: bottleName,
        type,
        entry_sum: Number(bottleAmount),
        available_until: availableUntil,
        start_date: startDate,
        target: targetOfBottle,
      })

      navigate('/create-bottle/created')
    } catch (err) {
      navigate('/create-bottle/not-created')
      const errorMessage = handleAxiosError(err)
      console.log(errorMessage)
    }

    clearAllFields()
  }

  return sendingRequestToCreateBottle
}
